<template>
    <div v-if="disabled" class="button" :class="{ 'button--disabled': disabled }">
        <slot />
    </div>
    <div v-else class="button" :class="{ 'button--clicked': clicked }" @click="$emit('click')">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        clicked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style lang="scss">
.button {
    user-select: none;
    height: 40px;
    box-sizing: border-box;
    padding: 10px 0;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    cursor: pointer;
    background-color: transparent;
    position: relative;
    transition: all 0.3s;
    overflow: hidden;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);

    &--disabled {
        background-color: transparent !important;
        color: #37474f !important;
        cursor: unset;
        box-shadow: unset;
    }

    &--clicked {
        background-color: $slate-two;
        color: $white;
        box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
    }

    &:hover:not(.button--clicked) {
        background-color: darken($color: $white, $amount: 4%);
    }

    &:after:not(.button--disabled) {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        background-image: radial-gradient(circle, #fff 10%, transparent 10%);
        background-repeat: no-repeat;
        background-position: 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition: transform 0.5s, opacity 1s;
    }

    &:active:after {
        transform: scale(0, 0);
        opacity: 0.3;
        transition: 0s;
    }
}
</style>
